import React, {Fragment} from 'react';
import SelectorGrid from '../form/SelectorGrid/SelectorGrid';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import Button from "../form/Button";
import MenuForm from "./forms/menuForm";
import MenuList from "./lists/menuList";

class menuEditor extends React.Component {

    render() {
        return (
            <Fragment>
                <Box
                    theme="default"
                >
                    <MenuList {...this.props} />
                </Box>
                <Box
                    theme="default"
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.props.saveForm }>
                            Mentés
                        </Button>,
                        <Button key="1" disabled={this.props.isLoading} color="default" className="pull-left" onClick={ this.props.pristineForm }>
                            Új
                        </Button>,
                        <Button
							key="2"
							disabled={this.props.isLoading}
							color="danger"
							className="pull-left"
							// onClick={() =>{
                            //     if (this.props.values[this.props.componentConfig.idfield]) {


                            //         const saveRequest = saveComponent("shippingorder", {
                            //             "groupage_id": null,
                            //             "id": 123,
                            //         });

                            //     } else {
                            //         this.props.values.shippingorders = [];
                            //     }
                            // } }
						>
                            Törlés
                        </Button>
                    ]}
                >
                    <MenuForm {...this.props} />
                </Box>
            </Fragment>
        );
    }
}
export default createEditor({componentName: "menu", WrappedComponent: menuEditor});
